import { render } from "./StakeV2.htm?vue&type=template&id=4e01d3dd&scoped=true"
import script from "./StakeV2.js?vue&type=script&lang=js"
export * from "./StakeV2.js?vue&type=script&lang=js"

import "./StakeV2.scss?vue&type=style&index=0&id=4e01d3dd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e01d3dd"]])

export default __exports__